import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://6914dbe6d7c538ae3e4de5e0925c76ef@o1149688.ingest.us.sentry.io/4507125854240768",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});
import { init } from 'astro/virtual-modules/prefetch.js';init()